import React, { createContext, useContext, ReactNode } from 'react';
import useOutageMap, { ALSMapProperties } from '../hooks/useOutageMap';

const OutageMapContext = createContext<ALSMapProperties | null>(null);

export const OutageMapProvider = ({ children }: { children: ReactNode }) => {
  const map = useOutageMap();
  return (
    <OutageMapContext.Provider value={map}>
      {children}
    </OutageMapContext.Provider>
  );
};

export const useOutageMapContext = () => {
  const ctx = useContext(OutageMapContext);
  if (!ctx) {
    throw new Error(
      'useOutageMapContext must be used inside OutageMapProvider',
    );
  }
  return ctx;
};
